import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import GradeFields from './GradeFields'

export const GradeCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <GradeFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default GradeCreate
